import _ from 'lodash';
import resetForm from './resetForm';

const _setFormData = (form, data) => {
    _.each(data, (value, prop) => {
        if (form.hasOwnProperty(prop)) {
            if (_.isObject(value)) {
                _setFormData(form[prop], value);
            } else if (_.isFunction(form[prop].onChange)) {
                form[prop].onChange(value);
            }
        }
    });
};

const setFormData = (form, data, defaults) => {
    if (defaults) {
        resetForm(form, defaults);
    }
   _setFormData(form, data);
};

export default setFormData;